import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { disableMaintenanceService } from '../../api/maintenance-service.ts';

export default function useDisableMaintenanceService(): UseMutationResult<
  Awaited<ReturnType<typeof disableMaintenanceService>>,
  Error,
  string
> {
  return useMutation({
    mutationFn: (serviceId: string) => disableMaintenanceService(serviceId),
  });
}
